export const setAlluserDetails = (data) => {
    return {
        type: "SET_ALL_USERS",
        allUsers: data,
    };
}

export const getAlluserDetails = (data) => {
    return {
        type: "GET_ALL_USERS",
    };
}